export const LOAD_PAGE_CONTENT = "LOAD_PAGE_CONTENT";
export const LOAD_PAGE_CONTENT_BLOCKS = "LOAD_PAGE_CONTENT_BLOCKS";
export const PAGE_CONTENT_LOADED = "PAGE_CONTENT_LOADED";
export const PAGE_CONTENT_BLOCKS_LOADED = "PAGE_CONENT_BLOCKS_LOADED";
